import React, { useCallback, useRef, useState } from 'react';
import styled from 'styled-components';
import { layout } from '../../config/styles';
import UserDropdown from '../../components/UserDropdown';
import UserPilotHelp from './UserPilotHelp';
import UniversalSearch from './UniversalSearch';
import BrowseFavoritesAction from './BrowseFavoritesAction';
import { UniversalSearchMenuControls } from './UniversalSearch/types';
import DataManagementDropdown from './DataManagementDropdown';
import HeaderMainNavigation from './HeaderMainNavigation';
import { HEADER_Z_INDEX } from '../../styles/zIndexes';
import { theme } from '../../styles/theme';

const Container = styled.header`
  flex: 0 0 ${layout.headerHeight}px;
  height: ${layout.headerHeight}px;
`;
const FixedContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${HEADER_Z_INDEX};
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 16px;
  width: 100%;
  height: ${layout.headerHeight}px;
  padding-right: 12px;
  padding-left: 12px;
  background-color: ${theme.colors.blue900};
`;
const MenusWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;
const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
`;

export default () => {
  const universalSearchRef = useRef<UniversalSearchMenuControls>(null);
  const [browsingFavorites, setBrowsingFavorites] = useState(false);

  const handleBrowseFavorites = useCallback(() => {
    if (universalSearchRef.current && !browsingFavorites) {
      setBrowsingFavorites(true);
      universalSearchRef.current.openMenuWithFavoritesOnly();
    }
  }, [browsingFavorites]);

  const handleToggleFavoritesOff = useCallback(() => {
    if (browsingFavorites) {
      setBrowsingFavorites(false);
    }
  }, [browsingFavorites]);

  return (
    <Container className={'header'}>
      <FixedContainer>
        <HeaderMainNavigation />
        <SearchContainer>
          <UniversalSearch
            ref={universalSearchRef}
            onToggleFavoritesOff={handleToggleFavoritesOff}
          />
          <BrowseFavoritesAction
            isActive={browsingFavorites}
            onClick={!browsingFavorites ? handleBrowseFavorites : undefined}
          />
        </SearchContainer>
        <MenusWrapper>
          <DataManagementDropdown />
          <UserPilotHelp />
          <UserDropdown />
        </MenusWrapper>
      </FixedContainer>
    </Container>
  );
};
